// extracted by mini-css-extract-plugin
var _1 = "ReadAloudButton__circleButtonImage--ZMY_M";
var _2 = "ReadAloudButton__circleShadow--DJSbi";
var _3 = "ReadAloudButton__mainBase--O1V5S";
export { _1 as "circleButtonImage", _2 as "circleShadow", _3 as "mainBase" }
